<template>
  <v-bottom-sheet fullscreen v-model="isActive">
    <div v-if="isActive && vehicle" class="dialog-vehicle">
      <div class="header">
        <div class="vehicle-name">
          <table style="width: 100%">
            <tr>
              <td>{{ vehicle.description }}</td>
              <td style="width: 32px">
                <div @click="close()" class="dialog-vehicle-close">
                  <v-icon color="#3e515f" size="30">mdi-close</v-icon>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <table class="vehicle-details">
          <tr>
            <td style="width: 65px">
              <img v-if="vehicle.vehicle_brand && vehicle.vehicle_brand.logo_url" :src="vehicle.vehicle_brand.logo_url" />
            </td>
            <td style="padding-top: 3px">
              <div class="value">{{ vehicle.year }}/{{ vehicle.year_model }}</div>
              <div class="description">Ano/Modelo</div>
            </td>
            <td style="padding-top: 3px">
              <div class="value">{{ vehicle.total_services }}</div>
              <div class="description">Serviços</div>
            </td>
            <td style="width: 105px">
              <img v-if="vehicle.vehicle_plate_photo_url" :src="vehicle.vehicle_plate_photo_url" height="95px" />
            </td>
          </tr>
        </table>
      </div>
      <div class="content">
        <div v-if="!serviceOrders.length" class="no-results">
          <v-img contain style="height: 110px; filter: grayscale(1); margin-bottom: 13px" :src="require('@/assets/vehicle-checklist.png')" />
          <h3>Nenhum serviço registrado ainda...</h3>
          <small>Lembre-se, para registrar os serviços do seu veículo o estabelecimento também deve estar utilizando o <b>CheckMotors</b>.</small>
        </div>
        <div v-for="serviceOrder in serviceOrders" :key="serviceOrder.id" class="service">
          <div class="service-header">
            <div v-if="serviceOrder.organization.logo_url" class="company-logo">
              <img :src="serviceOrder.organization.logo_url" height="36px" />
            </div>
            <div class="details">
              <div class="company-name">{{ serviceOrder.organization.name }}</div>
              <div class="company-type">
                {{ serviceOrder.organization?.organization_type ? serviceOrder.organization?.organization_type.name : 'EMPRESA AUTOMOTIVA' }}
              </div>
              <div class="service-date">{{ formatServiceDate(serviceOrder.created_at) }}</div>
            </div>
          </div>
          <div class="serice-description">{{ serviceOrder.description }}</div>
          <div class="d-service-photos">
            <v-carousel height="328px">
              <v-carousel-item v-for="(item, i) in serviceOrder?.service_order_photos" :key="i" :src="item.photo_url"></v-carousel-item>
            </v-carousel>
          </div>
          <div class="d-service-actions">
            <table>
              <tr>
                <td style="display: flex; align-items: center; justify-content: center" @click="openModalEvaluation(serviceOrder)">
                  <v-icon color="orange">
                    {{ serviceOrder?.service_order_evaluations?.length ? 'mdi-star-outline' : 'mdi-star' }}
                  </v-icon>
                  <span style="padding-top: 2px; padding-left: 5px">{{
                    serviceOrder?.service_order_evaluations?.length ? 'Avaliado' : 'Avaliar'
                  }}</span>
                </td>
                <td style="border-left: 1px solid #eee; border-right: 1px solid #eee" @click="printOS(serviceOrder)"><span>Visualizar</span></td>
                <td @click="shareOS(serviceOrder)"><span>Compartilhar</span></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <EvaluationModal
      :is-active="isModalEvaluationOpen"
      :service-order="evaluationServiceOrder"
      :evaluation="evaluation"
      @close="closeModalEvaluation"
      @save="saveModalEvaluation"
    />
  </v-bottom-sheet>
</template>

<script>
import dayjs from 'dayjs';
import EvaluationModal from './VehicleModal/EvaluationModal';

export default {
  components: { EvaluationModal },
  emits: ['close'],
  data() {
    return {
      serviceOrders: [],
      isModalEvaluationOpen: false,
      evaluation: null,
      evaluationServiceOrder: null
    };
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    vehicle: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    isActive(newValue) {
      if (!newValue) return;

      this.getServiceOrders();
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    openModalEvaluation(serviceOrder) {
      const evaluation = serviceOrder?.service_order_evaluations?.length ? serviceOrder?.service_order_evaluations[0] : null;

      this.evaluationServiceOrder = serviceOrder;
      this.evaluation = evaluation;
      this.isModalEvaluationOpen = true;
    },
    closeModalEvaluation() {
      this.isModalEvaluationOpen = false;
      this.evaluationServiceOrder = null;
      this.evaluation = null;
    },
    saveModalEvaluation() {
      this.closeModalEvaluation();
      this.getServiceOrders();
    },
    getServiceOrders() {
      this.$http.get(`/client/service_orders/vehicle/${this.vehicle.id}`).then((response) => {
        this.serviceOrders = response.data;
      });
    },
    formatServiceDate(date) {
      const dayjsDate = dayjs(date);
      return `${dayjsDate.format('DD/MM/YYYY')} às ${dayjsDate.format('HH:mm')}`;
    },
    printOS(serviceOrder) {
      const organizationUrl = this.getOrganizationUrl(serviceOrder);

      if (!organizationUrl) return;

      window.open(`${organizationUrl.value}/os/${serviceOrder.hash}`, '_blank');
    },
    shareOS(serviceOrder) {
      const organizationUrl = this.getOrganizationUrl(serviceOrder);

      if (!organizationUrl) return;

      window.open(`https://api.whatsapp.com/send?text=${organizationUrl.value}/os/${serviceOrder.hash}`);
    },
    getOrganizationUrl(serviceOrder) {
      return serviceOrder.organization.organization_parameters.find((parameter) => parameter.code === 'ORGANIZATION_DOMAIN_URL');
    }
  }
};
</script>
